import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { Button, Space } from 'tdesign-react';

import NovaDialog from '@/components/dialog';
import { Voice } from '@/interface/aigc';

import AigcVoiceComponent from '../AigcVoiceComponent';
import styles from './index.module.less';

export interface AigcVoiceDialogProps {
  data?: Voice;
  visible: boolean;
  onClose: () => void;
  onConfirm: (src?: Voice) => void;
}

const AigcVoiceDialog: React.FC<AigcVoiceDialogProps> = ({ data, visible, onClose, onConfirm }) => {
  const [src, setSrc] = useState<Voice | undefined>();

  useEffect(() => {
    setSrc(data);
  }, [data]);

  const handleConfirm = () => {
    onConfirm(src);
    onClose();
  };

  const getHeader = () => (
    <div className={styles.modalTitle}>
      <span style={{ flexGrow: 1, paddingLeft: 20 }}>选择角色语音包</span>
    </div>
  );

  const getFooter = () => (
    <div className={classNames('nova-modal-fixed-bottom-wrapper-end', styles.footer)}>
      <Space size={10}>
        <Button
          className="nova-info-button"
          size="medium"
          block
          theme="default"
          onClick={onClose}
        >
          取消
        </Button>
        <Button
          className="nova-info-button"
          size="medium"
          block
          onClick={handleConfirm}
        >
          确定
        </Button>
      </Space>
    </div>
  );

  const dialogConfig = {
    visible,
    closeBtn: false,
    destroyOnClose: true,
    closeOnOverlayClick: false,
    width: 1060,
    height: 680,
    placement: 'center' as 'center',
    style: { overflow: 'auto', padding: '20px 0' },
    className: styles.dialog,
    onCancel: onClose,
    onConfirm: handleConfirm,
    onClose,
    header: getHeader(),
    footer: getFooter(),
  };

  return (
    <NovaDialog dialogConfig={dialogConfig}>
      <AigcVoiceComponent
        data={src}
        onChange={setSrc}
      />
    </NovaDialog>
  );
};

export default AigcVoiceDialog;
